module.exports = __webpack_public_path__ + "static/media/img_37.76033d92.png";